import { cpus } from "os";

var m6CookiesBar = function () {
    var json = {
        "description": "En poursuivant votre navigation sur notre service ou en ouvrant nos communications directes, vous acceptez l’utilisation de cookies, y compris de partenaires tiers, pour réaliser des statistiques de visites, pour vous proposer des services et des publicités adaptés à vos centres d’intérêt (sur internet et via nos communications directes), pour vous proposer des fonctionnalités relatives aux réseaux sociaux ainsi que de la lecture directe de vidéos.",
        "btn_more": "En savoir plus et modifier les paramètres.",
        "btn_accept": "Accepter tous les cookies",
        "btn_prev": "Retour",        
        "show_partners": "Voir les partenaires",        
        "partners_filename": ""
    };

    var me = this;

    if (window.hasOwnProperty('m6GdprJSONExtra') && typeof m6GdprJSONExtra === 'object') {
        if (typeof m6GdprJSONExtra.bar_opts === 'object') {
            for (var attrname in m6GdprJSONExtra.bar_opts) {
                json[attrname] = m6GdprJSONExtra.bar_opts[attrname];
            }
        }
    }
    
    if (json.partners_filename !== undefined && json.partners_filename !== '') {    
        var partners = [];            
        var vendors = m6IABManager.getVendors();
        for (let i = 0; i < vendors.length; i++) {
            const element = vendors[i];
            var elementHtml = {
                type: 'li',
                class: 'vendor-li',
                text: element.name,
                children: (function () {
                    if (element.policyUrl !== "") {
                        return [{
                            type: 'a',
                            class: 'vendor-link',
                            text: '( Private Policy )',
                            attributes: {
                                href: element.policyUrl.indexOf('http') === 0 ? element.policyUrl : 'http://' + element.policyUrl,
                                target: '_blank',
                                rel: 'noopener'
                            }
                        }]
                    }
                })()
            }
            partners.push(elementHtml);
        }
        const jsonPartners = loadJSON(function (response) {
            var actual_JSON = JSON.parse(response);
            for (let i = 0; i < actual_JSON.length; i++) {
                const element = actual_JSON[i];
                var elementHtml = {
                    type: 'li',
                    class: 'vendor-li',
                    text: element.name,
                    children: (function () {
                        if (element.policyUrl !== "") {
                            return [{
                                type: 'a',
                                class: 'vendor-link',
                                text: '( Private Policy )',
                                attributes: {
                                    href: element.policyUrl.indexOf('http') === 0 ? element.policyUrl : 'http://' + element.policyUrl,
                                    target: '_blank',
                                    rel: 'noopener'
                                }
                            }]
                        }
                    })()
                }
                partners.push(elementHtml);
            }
        });
    }
    // class prefix
    me.prefix = 'm6Cookies';

    // set element breakpoints (mobile first !)
    me.mediaQueries = {
        large: '1000'
    };

    // scroll
    var scrollEvent = new m6CookiesScroll();
    var documentClickEvent = new m6CookiesDocumentClick();
 
    // create html elements
    me.html = m6CookiesEls.init([{
        type: 'div',
        class: me.prefix + 'partners-list-container',
        style: {
            default:'display:none; position: fixed; top: 0; left: 0; width: 100%; height: 100vh; overflow-x: hidden;overflow-y: scroll; background: #ffffff; z-index:10001;',
            large:'top: 50%; left: 50%; transform: translate(-50%, -50%); width: 650px; height: 550px; border-radius: 6px;'
        },
        children: [{
            type: 'div',
            class: 'btn-color-outline',
            click: function () {
                me.showPartners(),
                me.addScrollListener()
            },
            text: json.btn_prev,
            style: {
                default: 'cursor: pointer; display: inline-block; text-decoration:none; padding: 15px 25px; font-size:14px; line-height:18px; border: 1px solid #a5a3a3; color: #414141; font-weight: 600; font-family: Montserrat, sans-serif; letter-spacing: 0.4px; border-radius: 4px; margin: 20px 40px;',
                large: 'margin: 20px 60px;'
            }
        },
        {
            type: 'ul',
            class: 'partners-list',
            style: {
                default: 'margin: 0 10px 40px; list-style: none;',
                large: 'margin: 0 30px 40px'
            },
            children: (function () {
                if (json.partners_filename !== undefined && json.partners_filename !== '') {
                    return partners;
                }
            })()   
        }]
    },
    {
        class: me.prefix + 'partners-overlay',
        style: 'display: none; height: 100vh; width: 100%; background: rgba(30,30,30,0.8);position: fixed; top: 0; left:0; z-index: 10000;'
    },
    {
        class: me.prefix + '_bar',
        style: {
            default: 'background:#404040;position:fixed;bottom:0;left:0;right:0;z-index:10000;padding: 0.5rem;color:#fff;font-size:0.875rem;text-align:right;min-height: 32px;font-family: Arial, sans-serif;',
            large: 'padding-right:500px;padding-top:1rem;font-family: Arial, sans-serif;'
        },
        children: [
            {
                type: 'p',
                text: json.description,
                class: me.prefix + '_p',
                style: {
                    default: 'margin: 0 2rem 0.9375rem 0;text-align:justify; font-size: 12px;font-family: Arial, sans-serif;',
                    large: 'margin-bottom:0;font-family: Arial, sans-serif;margin:0 0 0.9375rem;'
                },
                children: (function() {
                    if (json.partners_filename !== undefined && json.partners_filename !== '') {
                        return [{
                            type: 'a',
                            text: json.show_partners,
                            class: 'show-partners',
                            style: 'display: block; color: #e8e8e8',
                            click: function() {
                                me.showPartners();
                                me.removeScrollListener()
                            }
                        }];                                                
                    }                
                })()
            },        
            {
                type: 'a',
                text: json.btn_more,
                class: me.prefix + '_btn',
                style: {
                    default: 'color: #fff;' +
                        'background: #555;' +
                        'display:inline-block;' +
                        'text-decoration:none;' +
                        'padding: 0 1rem;' +
                        'line-height:2rem;' +
                        'font-size: 12px;' +
                        'vertical-align:middle;' +
                        'margin: 0 0.5rem 1rem;' +
                        'font-family: Arial, sans-serif;' +
                        'width: calc(50% - 3rem);' +
                        'margin-right: .5rem;' +
                        'line-height: 1.2rem;' +
                        'margin-bottom: 0;' +
                        'box-sizing: content-box;' +
                        'text-align: center;',
                    large: 'position:absolute;' +
                        'top:1rem;' +
                        'right:15rem;' +
                        'margin: inherit;' +
                        'line-height: inherit;' +
                        'width: auto;' +
                        'padding: 0.5rem;' +
                        'font-family: Arial, sans-serif;'
                },
                click: function (e) {
                    new m6CookiesPopin();
                    me.close(e);
                }
            },
            {
                type: 'a',
                text: json.btn_accept,
                class: [me.prefix + '_btn', me.prefix + '_accept'],
                style: {
                    default: 'color:#333;' +
                        'background:#eee;' +
                        'font-size:12px;' +
                        'font-family: Arial, sans-serif;' +
                        'width: calc(50% - 3rem); ' +
                        'margin-left: .5rem;' +
                        'line-height: 1.2rem;' +
                        'margin-bottom: 0;' +
                        'box-sizing: content-box;' +
                        'text-align: center;',
                    large: 'right:3rem;' +
                        'font-family: Arial, sans-serif;' +
                        'margin: inherit;' +
                        'line-height: inherit;' +
                        'padding: 0.5rem;' +
                        'width: auto;'
                },
                click: function (e) {
                    window.dispatchEvent(new CustomEvent(m6Gdpr.REGISTER_GDPR_INFOS, { detail: { choices: '1:1,2:1,3:1,4:1' } }));
                    window.dispatchEvent(new CustomEvent(m6Gdpr.REGISTER_IAB_INFOS, { detail: { choices: null } }));
                    me.close(e);
                }
            }/*,
            {
                type: 'a',
                text: '&times;',
                class: [me.prefix + '_btn', me.prefix + '_close'],
                style: {
                    default: 'color:#333;' +
                        'background: #eee;' +
                        'border-radius: 50%;' +
                        'font-size: 1.5em;' +
                        'padding: 0 0.375rem;' +
                        'line-height: 1.5rem;' +
                        'position: absolute;' +
                        'top: .5rem;' +
                        'right: 0;' +
                        'width: auto;' +
                        'font-family: Arial, sans-serif;',
                    large: 'top: 1.25rem;' +
                        'right: 1rem;'
                },
                click: function (e) {
                    window.dispatchEvent(new CustomEvent(m6Gdpr.REGISTER_GDPR_INFOS, { detail: { choices: '1:1,2:1,3:1,4:1' } }));
                    window.dispatchEvent(new CustomEvent(m6Gdpr.REGISTER_IAB_INFOS, { detail: { choices: null } }));
                    me.close(e);
                }
            }*/
        ]
    }]);

    // create elements style
    me.styleheet = new m6CookiesStyles(me);

    me.showPartners = function () {
        scrollEvent.listen = false;
        document.getElementsByClassName(me.prefix + 'partners-list-container')[0].classList.toggle('dblock-container');
        document.getElementsByClassName(me.prefix + 'partners-overlay')[0].classList.toggle('dblock-container');
    }

    me.removeScrollListener = function() {
        scrollEvent.listen = false;
    }

    me.addScrollListener = function () {
        scrollEvent.listen = true;
    }

    var _tagStyle = document.createElement('style');
    _tagStyle.type = 'text/css';
    var style = '.dblock-container {display: block}';
    style += '.vendor-link{font-family: "Arial", sans-serif;color: #353535; font-size: 12px; display: inline-block; margin-left: 10px;}';
    style += '.vendor-li {font-family: "Arial", sans-serif; margin-bottom: 5px;}';
    _tagStyle.appendChild(document.createTextNode(style));
    var _bar = document.getElementsByClassName('m6Cookies_bar')[0];
    _bar.insertBefore(_tagStyle, _bar.nextSibling);

    function loadJSON(callback) {
        var xobj = new XMLHttpRequest();
        if(xobj.overrideMimeType)
            xobj.overrideMimeType("application/json");
        xobj.open('GET', 'https://gdpr.m6tech.net/gtm-partners/gtm-' + json.partners_filename + '.json', false);
        xobj.onreadystatechange = function () {
            if (xobj.readyState == 4 && xobj.status == "200") {
                callback(xobj.responseText);
            }
        };
        xobj.send(null);
    }

    // close cookie bar function
    me.close = function (e, doNotPreventDefault) {
        if (doNotPreventDefault === undefined) {
            doNotPreventDefault = false;
        }

        if (!doNotPreventDefault) {
            e.preventDefault();
        }
        scrollEvent.listen = false;
        documentClickEvent.listen = false;
        document.body.removeChild(me.html[0].html);
        document.body.removeChild(me.html[1].html);
        document.body.removeChild(me.html[2].html);
    };

    return me;

};
/**
 width: calc(50% - 3rem);
 margin-right: .5rem;
 line-height: 1.2rem;
 margin-bottom: 0;
 text-align: center;
 */

window.m6CookiesBar = m6CookiesBar;
